import z from 'zod';

export const SendSmsDialogSchema = z.object({
  message: z
    .string()
    .min(1, 'Message is required')
    .max(500, 'Message cannot exceed 500 characters'),
});
